import React from 'react';

import NarrowWidth from '@/components/common/layout/NarrowWidth';

import css from './RichtextWithBg.module.css';
const RichtextWithBg = props => {
  const { richtext } = props.value;

  return (
    <div className="w-full mt-10 bg-canvas-100">
      <NarrowWidth className="mx-auto">
        <div className="py-6 md:py-12">
          <div className={`text-xl leading-relaxed ${css.maxCharacterCount} ${css.richText}`}>
            {richtext && <div dangerouslySetInnerHTML={{ __html: richtext }} />}
          </div>
        </div>
      </NarrowWidth>
    </div>
  );
};

export default RichtextWithBg;
